import { useContextCampaign } from "../Campaign/ContextCampaign";
import {
  valuesDefaultInputsCampaign,
  valuesDefaultInputsGroupLeads,
  valuesDefaultInputsInstancesWhats,
} from "../Campaign/ValuesDefaultInputsCampaign/valuesDefaultInputsInstancesWhats";
import { useContextComissoes } from "../comissoes/ComissoesContext";
import { valuesDefaultInputsCommissions } from "../comissoes/ValuesDefaultInputsComissoes/ValuesDefaultInputsComissoes";
import { useConfigPageContext } from "../configPagesContext/configPagesContext";
import { useContextProfileContext } from "../ContextProfile/ContextProfile";
import { useContextDashboardContext } from "../Dashboard/ContextDashboardBroker";
import { valueDefaultFilterMetricsDashboard } from "../Dashboard/ValuesDefaultContextProfile/ValuesDefaultContextDashboardBroker";
import { useContextContrato } from "../Lancamentos/Contrato/ContratosContext";
import {
  valueDefaultInputReceivedInstallments,
  valueDefaultInputCancelContracts,
  valuesDefaultFilterInstallments,
  valuesDefaultFilterContrato,
  valueDefaultInputContratos,
} from "../Lancamentos/Contrato/valuesDefaultInputsContratos/ValueDefaultInputContratos";
import { useContextLeads } from "../Leads/LeadsContext";
import { valuesDefaultInputLeads } from "../Leads/valuesDefaultInputsLeads/ValueDefaultInputLeads";

import { UseAutoCompletedAll } from "../Utils/UseAutoCompletedAll";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useResetInputs = (isDisabledActive?: boolean) => {
  const {
    setValueAutoCompAdministradora,
    setValueAutoCompModalidade,
    setValueAutoCompOperadora,
  } = UseAutoCompletedAll();

  const {
    setValuesInputsCommissions,
    setValuesInputsAdministradora,
    setValuesInputsModalidade,
    setValuesInputsOperadora,
    setValuesInputsEmpresas,
  } = useContextComissoes();

  const { setFilterMetricsFilterDashboard } = useContextDashboardContext();
  const { setNameSearch, setId } = useConfigPageContext();
  const { setValuesUpdatePasswordUser } = useContextProfileContext();
  const { setValuesInputsLeads } = useContextLeads();
  const {
    setValuesInputsInstancesWhats,
    setValuesInputsGroupLeads,
    setValuesInputsCampaign,
  } = useContextCampaign();

  const {
    setValuesReceivedInstallment,
    setValuesFilterInstallments,
    setValuesInputsContrato,
    setValuesFilterContrato,
    setValuesCancelContract,
    setUploadFiles,
    setValuesGet,
  } = useContextContrato();

  const resetInputs = () => {
    setNameSearch("");
    setId("");
    setUploadFiles([]);

    setFilterMetricsFilterDashboard(valueDefaultFilterMetricsDashboard);
    setValuesReceivedInstallment(valueDefaultInputReceivedInstallments);
    setValuesInputsInstancesWhats(valuesDefaultInputsInstancesWhats);
    setValuesFilterInstallments(valuesDefaultFilterInstallments);
    setValuesInputsCommissions(valuesDefaultInputsCommissions);
    setValuesCancelContract(valueDefaultInputCancelContracts);
    setValuesInputsGroupLeads(valuesDefaultInputsGroupLeads);
    setValuesFilterContrato(valuesDefaultFilterContrato);
    setValuesInputsCampaign(valuesDefaultInputsCampaign);
    setValuesInputsContrato(valueDefaultInputContratos);
    setValuesInputsLeads(valuesDefaultInputLeads);
    setValuesGet(valueDefaultInputContratos);

    setValuesInputsEmpresas({ name: "", isActive: true });
    setValuesInputsOperadora({ name: "", isActive: true });
    setValuesInputsModalidade({ name: "", isActive: true });
    setValuesInputsAdministradora({ name: "", isActive: true });

    setValueAutoCompOperadora({ label: "", id: "" });
    setValueAutoCompModalidade({ label: "", id: "" });
    setValueAutoCompAdministradora({ label: "", id: "" });

    setValuesUpdatePasswordUser({
      passwordCurrency: "",
      passwordNew: "",
      newPasswordRepeat: "",
    });
  };

  return { resetInputs };
};
